import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SearchService } from '../../../services/search/search.service';
import { StorageService } from '../../../services/storage/storage.service';
import { Router } from '@angular/router';
import { SharedService } from '../../../services/shared/shared.service';
import { SearchQuery } from '../../../core/interfaces/search.interface';

export interface Itopicsearch {
  title: string;
  topicList: Itopic[];
}
export interface Itopic {
  description: string;
  query: string;
}

@Component({
  selector: 'topic-search',
  templateUrl: './topic-search.component.html',
  styleUrls: ['./topic-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TopicSearchComponent implements OnInit, OnChanges {
  @Input() headerTitle: any;
  @Input() rowClass: string;
  @Input() topicSearch: Itopicsearch[];
  @Input() className = 'pad-space';

  topicSearchObj: any;
  searchId: any;
  startRecord: any = 1;
  numOfRecords: any = 10;
  facetOffset: any = 0;
  numOfFacetPerGroup: any = 20;

  constructor(
    private _router: Router,
    private _searchService: SearchService,
    private _storage: StorageService,
    private _sharedService: SharedService,
  ) {}

  ngOnInit() {
    this.topicSearchObj = this.topicSearch;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.topicSearch?.currentValue) {
      this.topicSearchObj = changes.topicSearch.currentValue;
    }
  }

  chooseTopic(query) {
    if (this._storage.getItem('access_Token')) {
      query = query.searchQuery;
      // remove all the _id keys from the query
      const filters = query.filters;
      const matches = query.matches;
      // save the query terms in session to retain them on simple search
      let queryString = '';
      for (let index = 0; index < matches.length; index++) {
        const element = matches[index];
        if (index === 0) {
          queryString = element.query;
          this._storage.setItem('Search-TERM', queryString);
        } else {
          queryString = queryString + ',' + element.query;
          const q2 = this._storage.getItem('Search-TERM');
          const dummyStr = q2 + ' ' + element.query;
          this._storage.setItem('Search-TERM', dummyStr);
        }
      }
      this._storage.setItem('Search-TERM', queryString);

      matches.forEach((element) => {
        if (element.hasOwnProperty('_id')) {
          delete element._id;
        }
      });

      // default userType is none for the user for now.

      const searchQuery: SearchQuery = {
        matches: matches,
        resources: query.resources,
        facetOffset: query.facetOffset,
        numOfFacetPerGroup: query.numOfFacetPerGroup,
        startRecord: query.startRecord,
        numOfRecords: query.numOfRecords,
        orderBy: query.orderBy,
        resultType: query.resulttype,
        sortBy: query.sortBy,
        isKidsSearch: this._sharedService.getIsKidsCat(),
      };

      if (filters) {
        searchQuery['filters'] = filters;
      }

      const searchRequestPayload = { searchQuery: searchQuery };

      this._searchService.performSearch(searchRequestPayload).subscribe((response) => {
        this.searchId = response.searchId;
        const Cid = this._storage.getCid();
        const Lid = this._storage.getLid();
        this._router.navigate(['/search', Cid, Lid], {
          queryParams: {
            searchId: this.searchId,
            startRecord: this.startRecord,
          },
        });
      });
    }
  }
}
